import classNames from 'classnames';
import { Avatar } from 'flowbite-react';
import React from 'react';
import { buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { stringAvatar } from 'shared-utils';

interface Props {
  value: number;
  isSelf?: boolean;
  showLarge?: boolean;
  userName?: string;
  imageUrl?: string;
}

const MatchPercentageCircularBarComponentProfilePage = ({ isSelf, value, showLarge, userName, imageUrl }: Props) => {
  return !isSelf && value ? (
    <>
      <CircularProgressbarWithChildren
        styles={buildStyles({
          pathColor: value < 30 ? '#FF5C5C' : value < 70 ? '#FDAC42' : '#39D98A',
          trailColor: '#555770',
          strokeLinecap: 'round',
          pathTransitionDuration: 1,
          rotation: 0.566,
        })}
        strokeWidth={showLarge ? 9 : 11}
        circleRatio={0.88}
        value={value}
      >
        <div className="w-full h-full relative p-1 md:p-3">
          <div className="w-full h-full rounded-full overflow-hidden mx-auto bg-gray-600 flex items-center justify-center">
            {imageUrl ? (
              <img src={imageUrl} alt="User Profile" className="rounded-full h-full w-full object-cover" />
            ) : (
              <div className="text-center mx-auto text-4xl text-white">
                {stringAvatar(userName?.trim().toUpperCase() || '')}
              </div>
            )}
          </div>
        </div>
      </CircularProgressbarWithChildren>
      <div className="text-[8px] md:text-xs font-[500] bg-white rounded-[6px] border-[0.796px] border-[#F2F2F5] text-center max-w-fit mx-auto relative top-[-15px] py-1 px-2">
        {Math.round(value)}% Match
      </div>
    </>
  ) : (
    <div>
      <div className="w-full h-full relative">
        <div className="w-full h-full rounded-full overflow-hidden items-center justify-center">
          {imageUrl ? (
            <div
              className="w-full p-[2.133px] md:p-[4px] h-full rounded-full max-w-[120px] max-h-[120px] min-w-[72px] min-h-[72px] md:min-w-[120px] md:min-h-[120px] relative"
              style={{
                background: 'linear-gradient(147.14deg, #73DFE7 6.95%, #0063F7 93.05%)',
              }}
            >
              <img
                src={imageUrl}
                alt="User Profile"
                className="rounded-full h-[calc(100%-8px)] w-[calc(100%-8px)] object-cover absolute inset-0 m-auto"
              />
            </div>
          ) : (
            <div
              className="text-center p-[2.133px] md:p-[4px] mx-auto text-xl md:text-4xl text-gray-700 w-full h-full bg-yellow-300 flex items-center justify-center rounded-full max-w-[120px] max-h-[120px] min-w-[72px] min-h-[72px] md:min-w-[120px] md:min-h-[120px] relative"
              style={{
                background: 'linear-gradient(147.14deg, #73DFE7 6.95%, #0063F7 93.05%)',
              }}
            >
              <div className="h-[calc(100%-8px)] w-[calc(100%-8px)] rounded-full bg-yellow-300 flex items-center justify-center font-[700] absolute inset-0 m-auto">
                {stringAvatar(userName?.trim().toUpperCase() || '')}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MatchPercentageCircularBarComponentProfilePage;
